import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/ui/button';

/**
 * Route-level error boundary for feature routes, used as `errorElement` on individual routes so
 * a content failure is isolated to `main` — {@link AppShell}'s header/footer stay mounted and
 * visible around it.
 *
 * Shows the generic `portal.frame.content_error` message rather than the raw error detail: the
 * shell frame is organisation-type-agnostic and must not leak feature-internal error text.
 */
export function FeatureErrorBoundary() {
  const { t } = useTranslation('app');

  return (
    <div className="flex flex-col items-center justify-center gap-4 p-8" role="alert">
      <h2 className="text-xl font-semibold">{t('portal.frame.content_error')}</h2>
      <Button asChild variant="outline">
        <Link to="/">Zurück zur Startseite</Link>
      </Button>
    </div>
  );
}
